<template>
  <div>
    <el-dialog :title="$t('public58')" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialog.edit" width="25%" class="info-dialog">
      <el-form :model="formData" ref="formData" :rules="rules" class="form-data">
        <el-form-item prop="email">
          <el-input v-model="formData.email" :placeholder="$t('public59')"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input  v-model="formData.code" :placeholder="$t('user116')">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
          <I18Lang id="user84" defaultText="提交" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import SendCode from '@/components/SendCode/SendCode.vue'
import i18n from '@utils/i18n'

export default {
  name: 'record',
  data () {
    const validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public10'))) // 请输入邮箱
      } else {
        var emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i
        if (!emailRegex.test(value)) {
          callback(new Error(i18n.t('public11'))) // '邮箱格式有误，请重填'
          return false
        } else {
          callback()
        }
      }
    }

    return {
      sendLoading: false,
      isSendCode: false,
      dialog: {
        edit: false
      },
      formData: {
        email: '',
        code: ''
      },
      rules: {
        email: [
          { required: true, validator: validateEmail, trigger: 'blur' }
        ],
        code: [
          { required: true, message: i18n.t('user25'), trigger: 'blur' }
        ]
      }
    }
  },
  components: {

  },
  methods: {
    showDialog () { // 修改类型
      this.dialog.edit = true
    },
    async sendEmailCode () { // 发送验证码
      this.$refs.formData.validateField(['email'], result => {
        if (!result) {
          this.submitSendEmailAuthCode()
        }
      })
    },
    submitSendEmailAuthCode () {
      const params = {
        email: this.formData.email,
        event: 'update_email'
      }
      this.sendLoading = true
      this.$http.post('/api/email/send', params, { direct: true }).then((result) => {
        if (result.code === 200) {
          this.isSendCode = true
          this.sendLoading = false
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.sendLoading = false
      })
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData () {
      this.$http.post('/api/user/editEmail', this.formData).then(result => {
        this.dialog.edit = false
        this.$emit('onUpdata')
        this.$message.success(this.$t('public16'))
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 380px;
    height: 380px;
    background: url("../../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .el-input-group__append {
      background: transparent;
      border: 1px solid rgba(1, 178, 245, 0.5);
      border-left: none;

      button {
        cursor: pointer;
        color: #fff;
      }

    }

    .el-dialog__body {
      padding-bottom: 10px;
    }

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01B2F5;
        margin-bottom: 10px;
      }

      .form-item-value {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: rgb(#FFFFFF, 0.6);
      }
    }
  }
}
</style>
